import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutOffPayeeList extends Layout {
    layoutheaderOffPayee: LayoutHeader;
    sourceOffPayee: DataSource;
    tableOffPayee: Table;
}
